<script lang="ts" setup>
import BasicButton from '~/components/form-elements/BasicButton.vue'
import BasicToCartButton from '~/components/form-elements/BasicToCartButton.vue'
import QuantityCounter from '~/components/form-elements/QuantityCounter.vue'
import { useProduct } from '~/composables/product'
import { useStickyObserver } from '~/composables/sticky-observer'
import Page from '~/enums/page'
import { useProductsStore } from '~/store/products'

const props = withDefaults(
  defineProps<{
    multiplicity?: number
    productId: string
  }>(),
  { multiplicity: 1 }
)

const productsStore = useProductsStore()
const { isHidden } = useStickyObserver('product-next-button')

const { addProductToCart, setCartProductQuantity } = useProduct()

const quantity = computed({
  get (): number {
    return productsStore.getCartProductQuantity(props.productId) ?? 0
  },
  set (quantity: number): void {
    setCartProductQuantity(props.productId, quantity)
  }
})
</script>

<template>
  <div
    class="
      fixed inset-x-0 bottom-[54px] z-[9999] w-full bg-white px-3 pb-3 pt-2 shadow-[0_-4px_13px_0_rgba(0,0,0,0.25)]
      transition-all duration-500 ease-in-out sm:hidden
    "
    :class="{ 'translate-y-full opacity-0': isHidden, 'translate-y-0 opacity-100': !isHidden }"
  >
    <div v-if="quantity" class="flex items-center justify-between">
      <BasicToCartButton class="mr-1.5 !w-full !max-w-[calc(100%-6px)]" />

      <QuantityCounter
        v-model="quantity"
        class="ml-1.5 !h-full w-full !max-w-[сalc(100%-6px)] justify-center space-x-4"
        is-wide-on-mobile
        :min="0"
        :multiplicity="multiplicity"
      />
    </div>
    <BasicButton
      v-else
      class="!h-[44px] w-full"
      color="green"
      :title="'В\xA0корзину'"
      @click="addProductToCart(productId, multiplicity)"
    />
  </div>
</template>
